module.exports = __webpack_public_path__ + "img/ps-afiliacion.07c348da.jpg";